import React from 'react'
import { useBrandFilter } from '../../contexts/brand-filter-context'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import './DivisionSelector.css'

const DivisionSelector = () => {
  useDocumentTitle('Select Division')
  const { setBrand: setDivision } = useBrandFilter()

  // Pointer-reactive spotlight. Writes CSS custom properties directly to the
  // hovered card's DOM node — no React state, so it never triggers a re-render
  // and stays composited to that single element. Gated to fine pointers in CSS.
  const handleCardPointerMove = (e) => {
    const el = e.currentTarget
    const rect = el.getBoundingClientRect()
    el.style.setProperty('--mx', `${((e.clientX - rect.left) / rect.width) * 100}%`)
    el.style.setProperty('--my', `${((e.clientY - rect.top) / rect.height) * 100}%`)
  }

  return (
    <div className="division-selector-page">
      <div className="division-selector-content">
        <div className="division-selector-header">
          <img src="logo/short_circuit.png" alt="Short Circuit" className="division-logo" />
          <h1 className="division-title">Welcome to Short Circuit</h1>
          <p className="division-subtitle">Select your division to get started</p>
        </div>

        <div className="division-cards">
          <button
            className="division-card division-card-edc"
            onClick={() => setDivision('EDC')}
            onMouseMove={handleCardPointerMove}
          >
            <div className="division-card-logo">
              <img src="logo/edc-logo.svg" alt="EDC" className="division-brand-logo edc-brand-logo" />
            </div>
            <p className="division-card-desc">
              Edward Davies Commercials Ltd. — All projects and design work
            </p>
            <span className="division-card-action">
              Enter EDC <span className="division-card-arrow" aria-hidden="true">&rarr;</span>
            </span>
          </button>

          <button
            className="division-card division-card-msrt"
            onClick={() => setDivision('MS-RT')}
            onMouseMove={handleCardPointerMove}
          >
            <div className="division-card-logo">
              <img src="logo/ford-x-msrt-logo.svg" alt="MS-RT" className="division-brand-logo msrt-brand-logo" />
            </div>
            <p className="division-card-desc">
              Ford vehicle projects — Performance & aftermarket design
            </p>
            <span className="division-card-action">
              Enter MS-RT <span className="division-card-arrow" aria-hidden="true">&rarr;</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default DivisionSelector
